<template>
  <div id="app" class="app">
    <div class="app-left">
      <app-inquiries></app-inquiries>
      <left-navigation v-if="leftNavigation"></left-navigation>
    </div>
    <div id="appMain" class="app-main" :style= "[inquiriesValue ? {marginRight: '-35vw'} : null]" @click="closeInquiriesCheck($event)">
      <div class="app-header">
        <app-header
          :style= "[leftNavigation ? {left: '90vw', zIndex: 1000000} : null]"
          :class="{ moveNav: inquiriesValue, headerBuilding: $route.name === 'building' }"
          :inquiries="inquiriesValue"></app-header>
      </div>
      <div class="app-pages">
          <keep-alive>
              <transition name="fade">
                  <router-view @click.native="closeInquiries"></router-view>
              </transition>
          </keep-alive>
      </div>
    </div>
      <script type="application/ld+json">
          {
              "@context": "http://schema.org",
              "@type": "Residence",
              "name": "Parker West",
              "alternateName": "Parker West | Upper West Side Condominiums",
              "url": "https://test.parkerwest.com/",
              "image": "http:\/\/test.parkerwest.com\/uploaded_images\/terrace-1xfoMHDDYyjrECGo.jpg",
              "description": "Parker West reimagines sophisticated, boutique living in one of New York's most iconic neighborhoods. Residents enjoy private full-floor homes in the heart of the Upper West Side.",
              "telephone": "",
              "address": [{
                  "@type": "PostalAddress",
                  "addressLocality": "New York",
                  "addressRegion": "NY",
                  "postalCode": "10023",
                  "streetAddress": "214 West 72nd Street"
              }]
          }
      </script>
    </div>
</template>

<script>
  import Header from "./components/Header";
  import Inquiries from "./components/Inquiries";
  import LeftNavigation from "./layouts/LeftNavigation";
  export default {
    name: "App",
    metaInfo: {
        title: 'Parkerwest',
        // Define meta tags here.
        meta: [
          {name: 'description', content: 'Parkerwest description'},
          {name: 'robots', content: 'index,follow'}
        ],
        link: [
            {rel: 'canonical', href: 'http://test.parkerwest.com/'}
        ]
    },
    components: {
      'left-navigation': LeftNavigation,
      'app-header': Header,
      'app-inquiries': Inquiries
    },
    data: () => ({
      inquiriesValue: false,
      leftNavigation: false,
      activateHeaderMethod: false
    }),
    created() {
      this.$bus.on('showInquiries', (value) => {
        const root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
        if (value) {
          root.classList.add('inquiriesEnabled' );
        } else {
          root.classList.remove( 'inquiriesEnabled' );
        }

        this.inquiriesValue = value
      });
      this.$bus.on('leftNavigation', (value) => {
        this.leftNavigation = value
      });
      this.$bus.on('showInquiriesOpen', (value) => {
            this.activateHeaderMethod = value
      });
      window.addEventListener("orientationchange", function() {
         location.reload()
      });
    },
    mounted() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    methods: {
      closeInquiries() {
        this.$bus.emit('showInquiries', false);
      },
      closeInquiriesCheck() {
        if (this.activateHeaderMethod)  {
            this.$bus.emit('showInquiries', false);
            // event.stopPropagation();
        }
      }
    }
  }
</script>

<style lang="scss">
  @import './scss/main';
  .moveNav {
      left: 35vw;
      z-index: 1000000;

      @include multiple-media(tabletScreen) {
          left: 65vw;
          width: 100%;
      }

      @include multiple-media(tabletScreenLandscape, tabletScreenLandscapePro) {
          left: 50vw;
          width: 100%;
      }
  }
</style>
